<div class="push-chart experimental-marker" [title]="'audiences.destinations.pushTrendHint' | translate">
  <app-audience-volumes-trend-chart
    *ngIf="hasData; else placeholder"
    [volumesData]="trend"
    [compact]="true"
    [heightPx]="34">
  </app-audience-volumes-trend-chart>
  <ng-template #placeholder>
    <span class="push-chart__empty">—</span>
  </ng-template>
</div>
